<template>
  <validation-observer
    id="stepQuestionsForm"
    ref="form"
    tag="form"
    novalidate
    @submit.prevent="handleSubmitQuestions"
  >
    <vvs-questions
      :questions.sync="questions"
      :form-questions="form.questions"
      :static-questions="staticQuestions"
      :question-start-number="1"
    ></vvs-questions>

    <vvs-recaptcha
      v-if="showRecaptcha"
      name="Google Recaptcha"
      validate="required"
      v-model="googleVerifyKey"
    ></vvs-recaptcha>

    <vvs-submit-button
      title="İLERİ &gt;"
      description="* doldurulması zorunlu alan"
    ></vvs-submit-button>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';
import staticQuestions from '@/data/supplier-questions';

export default {
  name: 'StepQuestions',
  mixins: [stepsMixin],
  data() {
    return {
      questions: [],
      staticQuestions: [],
    };
  },
  methods: {
    async handleSubmitQuestions() {
      await this.handleSubmit(async () => {
        this.form.questions = [...this.questions];
      });
    },
    setStaticQuestions() {
      this.staticQuestions = staticQuestions.map(staticQuestion => {
        return {
          ...staticQuestion,
          questionAnswers: staticQuestion.questionAnswers.map(
            questionAnswer => {
              const answer =
                questionAnswer instanceof Object
                  ? questionAnswer.answer
                  : questionAnswer;
              return answer;
            }
          ),
        };
      });
    },
    setSegmentByAnswers() {
      let totalPoint = 0;
      this.questions.forEach(({ name, type, answers }) => {
        if (type !== 'type' && answers.length > 0) {
          const { questionAnswers } = staticQuestions.find(
            ({ question }) => question === name
          );

          answers.forEach(answer => {
            const { point } = questionAnswers.find(
              questionAnswer => questionAnswer.answer === answer
            );

            totalPoint += point;
          });
        }
      });

      if (totalPoint < 15) {
        this.$store.commit('supplier/setSegment', { segment: 'starter' });
      } else if (totalPoint >= 15 && totalPoint <= 25) {
        this.$store.commit('supplier/setSegment', { segment: 'bronze' });
      } else {
        this.$store.commit('supplier/setSegment', { segment: 'silver' });
      }
    },
  },
  watch: {
    questions: {
      handler() {
        this.setSegmentByAnswers();
      },
      deep: true,
    },
  },
  created() {
    this.setStaticQuestions();
  },
};
</script>
